import { render, staticRenderFns } from "./BranchInfoCard.vue?vue&type=template&id=54e66d2d&scoped=true&"
import script from "./BranchInfoCard.vue?vue&type=script&lang=js&"
export * from "./BranchInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./BranchInfoCard.vue?vue&type=style&index=0&id=54e66d2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e66d2d",
  null
  
)

export default component.exports